<template>
  <div style="padding: 0 15px">
    <a-row v-if="!viewRecord.id" :gutter="24">
      <div
        v-if="planList.length && !loading"
        class="scroll-container box-shadow-1"
        ref="scrollContainer"
        @scroll="handleScroll"
      >
        <a-col v-for="(item, index) in planList" :key="index" :span="12" class="plan-card">
          <a-card style="border-radius: 5px; padding: 0 10px">
            <div class="plan-card-content">
              <div>
                <div>
                  <span class="title" style="margin-right: 10px">{{ item.title }}</span>
                  <!--                  <a-tag :color="item.color">-->
                  <!--                    {{ getDictCodeData(item.status) }}-->
                  <!--                  </a-tag>-->
                  <a-tag :color="item.rate > 0 ? 'blue' : ''">
                    {{ item.rate > 0 ? '已完成' : '待完成' }}
                  </a-tag>
                  <span v-show="item.status == 0" class="action-icon transparent-area-appear">
                    <a-icon
                      type="edit"
                      :style="{ fontSize: '18px', color: '#1783E8', marginRight: '10px' }"
                      @click.stop="editCard(item)"
                    />
                    <a-popconfirm title="是否删除该卡片？" @confirm="deleteCard(item)">
                      <a-icon
                        type="delete"
                        :style="{ fontSize: '18px', color: '#FF4D4F' }"
                        @click.stop="() => {}"
                      />
                    </a-popconfirm>
                  </span>
                </div>
                <div style="margin-top: 10px">
                  活动日期:
                  <span v-if="item.beginDate && item.endDate">
                    {{ item.beginDate }} 至 {{ item.endDate }}
                  </span>
                  <span v-else>无</span>
                </div>
                <a-button type="primary" style="margin-top: 10px" @click="showPlanDetail(item)">
                  查看详情
                </a-button>
              </div>
              <a-progress type="circle" :strokeColor="item.color" :percent="item.rate">
                <template #format="percent">
                  <div>
                    <div style="font-size: 24px; font-weight: bold">{{ percent }}%</div>
                    <div style="margin-top: 10px">完成进度</div>
                  </div>
                </template>
              </a-progress>
            </div>
          </a-card>
        </a-col>
      </div>
      <a-col v-else :span="24">
        <EmptyData :loading="loading" :isSetPageCenter="true" />
      </a-col>
    </a-row>
    <template v-else>
      <component :is="componentList[type]" :viewRecord="viewRecord" />
    </template>
  </div>
</template>
<script>
import { getDictCodeData } from '@/utils/util'
import { getAction } from '@api/manage'
import ClassCompleteDetail from '@/comUi/ClassCompleteDetail'
import ClassMoodDetail from './components/ClassMoodDetail'

export default {
  name: 'AssessmentPlan',
  components: {
    ClassCompleteDetail,
    ClassMoodDetail,
  },
  props: {
    titleList: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '3',
    },
    classId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      planList: [],
      viewRecord: {},
      total: 0,
      loading: false,
      componentList: {
        3: 'ClassCompleteDetail',
        4: 'ClassMoodDetail',
      },
    }
  },
  created() {
    this.getPlanList()
  },
  watch: {
    // 监听titleList
    titleList: {
      handler(newVal) {
        if (newVal.length < 3) {
          this.viewRecord = {}
        }
      },
      immediate: true,
    },
  },
  methods: {
    getDictCodeData(status) {
      return getDictCodeData('assessment_status', status).text || ''
    },
    handleScroll() {
      const container = this.$refs.scrollContainer
      // 检查是否滚动到底部
      if (
        container.scrollTop + container.clientHeight >= container.scrollHeight &&
        this.total > this.planList.length
      ) {
        this.pageNo += 1
        this.getPlanList()
      }
    },
    getPlanList() {
      this.loading = true
      getAction('/schoolEvaluationPlan/list', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        classIds: this.classId,
      }).then((res) => {
        if (res.success) {
          this.total = res.result.total
          this.loading = false
          const planList = res.result.records.map((item) => {
            const rate = (item.finishStudentNum / item.planStudentNum) * 100
            return {
              ...item,
              id: item.id,
              title: item.name,
              status: item.status,
              time: item.createTime,
              rate: rate && rate.toFixed(1),
              color: '#1783E8',
              tag: 0, // tag: 0 代表测评，1 代表活动
            }
          })
          this.planList.push(...planList)
        }
      })
      console.log('计划列表：', this.planList)
    },
    showPlanDetail(data) {
      console.log('查看详情：', data)
      this.viewRecord = data
      if (this.type == '3') {
        this.$emit('addTitleList', '评测详情')
      } else {
        this.$emit('addTitleList', '评测详情')
      }
    },
  },
}
</script>
<style scoped lang="less">
.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.plan-card {
  margin-bottom: 20px;
  /deep/ .ant-card-body {
    padding: 12px;
  }
  .plan-card-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.scroll-container {
  height: 82vh; /* 设置一个固定高度 */
  padding: 20px 5px;
  border-radius: 8px;
  overflow: hidden;
  overflow-y: scroll; /* 启用垂直滚动 */
}
</style>
